class RouterManger {
    constructor(){        
        this.routers = {}
    }
    addRouter(name,r){      
        
        this.routers[name] = r
    }

    getRouter(name){
        return this.routers[name];
    }
    
}


const routerManager = new RouterManger()
export default routerManager